import type { UserRow } from "./api";

export type UserRoleValue = "admin" | "staff" | "user";
export type UserStatus = "active" | "locked" | "inactive";

export function getRole(user: Pick<UserRow, "is_superuser" | "is_staff">): UserRoleValue {
  if (user.is_superuser) return "admin";
  if (user.is_staff) return "staff";
  return "user";
}

export function roleLabel(role: UserRoleValue): string {
  switch (role) {
    case "admin":
      return "Administrador";
    case "staff":
      return "Operador";
    case "user":
      return "Utilizador";
  }
}

export function rolePayload(role: UserRoleValue): { is_superuser: boolean; is_staff: boolean } {
  switch (role) {
    case "admin":
      return { is_superuser: true, is_staff: true };
    case "staff":
      return { is_superuser: false, is_staff: true };
    case "user":
      return { is_superuser: false, is_staff: false };
  }
}

export function getStatus(user: Pick<UserRow, "is_active" | "locked_at">): UserStatus {
  if (user.locked_at) return "locked";
  if (!user.is_active) return "inactive";
  return "active";
}

export function statusLabel(status: UserStatus): string {
  switch (status) {
    case "active":
      return "Activo";
    case "locked":
      return "Bloqueado";
    case "inactive":
      return "Inactivo";
  }
}

export function fullName(user: Pick<UserRow, "first_name" | "last_name" | "username">): string {
  const name = `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim();
  return name || user.username;
}
